import { render, staticRenderFns } from "./SampleMasterDetail.vue?vue&type=template&id=f660cec0"
import script from "./SampleMasterDetail.vue?vue&type=script&lang=js"
export * from "./SampleMasterDetail.vue?vue&type=script&lang=js"
import style0 from "./SampleMasterDetail.vue?vue&type=style&index=0&id=f660cec0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports